import React, { Component } from 'react';
import PropTypes from 'prop-types';

class CompanyItem extends Component {
  constructor(props) {
    super(props);
    this.handleClick = this.handleClick.bind(this);
  }

  handleClick(e) {
    e.preventDefault();
    const { id, onClick, onChangeCompany } = this.props;

    if (onChangeCompany) {
      onClick();
      onChangeCompany(id);
    } else {
      document.location = `/?company_id=${id}`;
    }

    onClick();
  }

  render() {
    const { id, groupId, name } = this.props;

    return (
      <button
        title={`${groupId}-${id}`}
        onClick={this.handleClick}
        className={'account__menu__item'}
        type="button"
      >
        {name} ({groupId}-{id})
      </button>
    );
  }
}

CompanyItem.propTypes = {
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  groupId: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  onChangeCompany: PropTypes.func,
};

export default CompanyItem;
